import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import AppNavbar from '../AppNavbar';
import './legal.css';

class Glbf extends Component {
    render() {
        return (
            <div>
                <AppNavbar />
                <div className="privacyBox">
                        <div href="" class="rte-blog w-richtext">
                                <p className="c9 c18">Rev. Sept. 2024</p>
                                <table className="c36">
                                    <tbody>
                                    <tr className="c8" >
                                        <td className="bold-white-black-text" >
                                            <p className="c16"><span className="c21"><strong>FACTS</strong></span></p>
                                        </td>
                                        <td className="c46">
                                            <p className="c9 c18">
                                                <span className="c14"><strong>WHAT DOES ALUMSUM LLC (“ALUMSUM”) DO WITH YOUR PERSONAL INFORMATION?</strong></span>
                                            </p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <p className="c59 c18 c29"></p>
                                <table className="c36">
                                    <tbody>
                                    <tr className="c2">
                                        <td className="bold-white-grey-text">
                                            <p className="c16"><span className="c12"><strong>Why?</strong></span></p>
                                        </td>
                                        <td className="c56">
                                            <p className="c9 c18">
                                                <span className="c3">Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share, and protect your personal information. Please read this notice carefully to understand what we do.</span>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="c70">
                                        <td className="bold-white-grey-text">
                                            <p className="c9 c18"><span className="c12"><strong>What?</strong></span></p>
                                        </td>
                                        <td className="c56">
                                            <p className="c9 c18">
                                                <span className="c3">The types of personal information we collect and share depend on the product or service you have with us. This information can include:</span>
                                            </p>
                                            <ul className="c28 lst-kix_list_1-0 start">
                                                <li className="c18 c31"><span className="c3">Social Security number and income,</span></li>
                                                <li className="c31 c18"><span className="c3">account balances and payment history,</span></li>
                                                <li className="c31 c18"><span className="c3">credit history and credit scores.</span></li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr className="c2">
                                        <td className="bold-white-grey-text">
                                            <p className="c9 c18"><span className="c12"><strong>How?</strong></span></p>
                                        </td>
                                        <td className="c56">
                                            <p className="c9 c18">
                                                <span className="c3">All financial companies need to share customers’ personal information to run their everyday business. In the section below, we list the reasons financial companies can share their customers’ personal information; the reasons AlumSum chooses to share; and whether you can limit this sharing.</span>
                                            </p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <p className="c29 c59"></p>
                            <table className="c36">
                                <tbody>
                                <tr className="c2">
                                    <td className="bold-white-grey-text">
                                        <p className="c9 c18"><span className="c17"><strong>Reasons we can share your personal information</strong></span></p>
                                    </td>
                                    <td className="bold-white-grey-text">
                                        <p className="c9 c18"><span className="c3"><strong>Does AlumSum share?</strong></span></p>
                                    </td>
                                    <td className="bold-white-grey-text">
                                        <p className="c9 c18"><span className="c3"><strong>Can you limit this sharing?</strong></span></p>
                                    </td>
                                </tr>
                                <tr className="c2">
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c3"><strong>For our everyday business purposes—</strong>
                                            such as to process your transactions,
                                            maintain your account(s), respond to court orders and legal investigations,
                                            or report to credit bureaus</span></p>
                                    </td>
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c3">Yes</span></p>
                                    </td>
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c3">No</span></p>
                                    </td>
                                </tr>
                                <tr className="c2">
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c17"><strong>For our marketing purposes—</strong>
                                            to offer our products and services to you</span></p>
                                    </td>
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c3">Yes</span></p>
                                    </td>
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c3">No</span></p>
                                    </td>
                                </tr>
                                <tr className="c2">
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c17"><strong>For joint marketing with other financial companies</strong></span></p>
                                    </td>
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c3">No</span></p>
                                    </td>
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c3">No</span></p>
                                    </td>
                                </tr>
                                <tr className="c2">
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c17"><strong>For our affiliates’ everyday business purposes—</strong>information about your transactions and experiences</span></p>
                                    </td>
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c3">No</span></p>
                                    </td>
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c3">We don't share</span></p>
                                    </td>
                                </tr>
                                <tr className="c2">
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c17"><strong>For our affiliates’ everyday business purposes—</strong>information about your creditworthiness</span></p>
                                    </td>
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c3">No</span></p>
                                    </td>
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c3">We don't share</span></p>
                                    </td>
                                </tr>
                                <tr className="c2">
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c17"><strong>For nonaffiliates to market to you</strong></span></p>
                                    </td>
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c3">No</span></p>
                                    </td>
                                    <td className="c49">
                                        <p className="c9 c18"><span className="c3">We don't share</span></p>
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                                <p className="c29 c59"></p>
                                <table className="c64">
                                    <tbody>
                                    <tr className="c44">
                                        <td className="bold-white-grey-text">
                                            <p className="c47 c18"><span className="c12"><strong>Questions?</strong></span></p>
                                        </td>
                                        <td className="c57">
                                            <p className="c18 c54">
                                                <span className="c3">Visit us at: </span>
                                                <span className="c26"><a className="c7" href="https://alumsum.com/contact">https://alumsum.com/contact</a></span>
                                                <span className="c3"><br />Email us at: </span>
                                                <span className="c26"><a className="c7" href="mailto:support@alumsum.com">support@alumsum.com</a></span>
                                            </p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <p className="c59 c29"></p>
                                <table className="c36">
                                    <tbody>
                                    <tr className="c52">
                                        <td className="bold-white-grey-text" colSpan="2">
                                            <p className="c16"><span className="c12"><strong>What we do</strong></span></p>
                                        </td>
                                    </tr>
                                    <tr className="c2">
                                        <td className="c22">
                                            <p className="c9 c18"><span className="c17"><strong>How does AlumSum protect my personal information?</strong></span></p>
                                        </td>
                                        <td className="c49">
                                            <p className="c9 c18"><span className="c3">To protect your personal information from unauthorized access and use, we use security measures that comply with federal law. These measures include computer safeguards and secured files and buildings. We require companies that work for and with us to protect your information.</span></p>
                                        </td>
                                    </tr>
                                    <tr className="c39">
                                        <td className="c22">
                                            <p className="c9 c18"><span className="c17"><strong>How does AlumSum collect my personal information?</strong></span></p>
                                        </td>
                                        <td className="c49">
                                            <p className="c9 c18"><span className="c3">We collect your personal information, for example, when you:</span></p>
                                            <ul className="c28 lst-kix_list_2-0 start">
                                                <li className="c19 c18"><span className="c3">Open an account or seek financial or tax advice,</span></li>
                                                <li className="c18 c19"><span className="c3">Give us your contact information or give us your income information,</span></li>
                                                <li className="c19 c18"><span className="c3">Apply for a loan or make payments on your loan.</span></li>
                                            </ul>
                                            <p className="c18 c71"><span className="c3">We also collect your personal information from others, such as credit bureaus or other companies.</span></p>
                                        </td>
                                    </tr>
                                    <tr className="c39">
                                        <td className="c22">
                                            <p className="c9 c18"><span className="c17"><strong>Why can’t I limit all sharing?</strong></span></p>
                                        </td>
                                        <td className="c49">
                                            <p className="c9 c18"><span className="c3">Federal law gives you the right to limit only</span></p>
                                            <ul className="c28 lst-kix_list_3-0 start">
                                                <li className="c19 c18"><span className="c3">sharing for affiliates’ everyday business purposes—information about your creditworthiness;</span></li>
                                                <li className="c19 c18"><span className="c3">affiliates from using your information to market to you</span></li>
                                                <li className="c19 c18"><span className="c3">sharing for non-affiliates to market to you.</span></li>
                                            </ul>
                                            <p className="c9 c18"><span className="c3">State laws and individual companies may give you additional rights to limit sharing. See below for more information on your rights under state law.</span></p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <p className="c59 c18 c29"></p>
                                <table className="c36">
                                    <tbody>
                                    <tr className="c52">
                                        <td className="bold-white-grey-text" colSpan="2">
                                            <p className="c16"><span className="c12"><strong>Definitions</strong></span></p>
                                        </td>
                                    </tr>
                                    <tr className="c23">
                                        <td className="c22">
                                            <p className="c9 c18"><span className="c17"><strong>Affiliates</strong></span></p>
                                        </td>
                                        <td className="c49">
                                            <p className="c9 c18"><span className="c27">Companies related by common ownership or control. They can be financial and nonfinancial companies.</span></p>
                                            <ul className="c28 lst-kix_list_4-0 start">
                                                <li className="c19 c18"><span className="c50">AlumSum has no affiliates.</span></li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr className="c67">
                                        <td className="c22">
                                            <p className="c9 c18"><span className="c17"><strong>Nonaffiliates</strong></span></p>
                                        </td>
                                        <td className="c49">
                                            <p className="c9 c18"><span className="c27">Companies not related by common ownership or control. They can be financial and nonfinancial companies.</span></p>
                                            <ul className="c28 lst-kix_list_5-0 start">
                                                <li className="c19 c18"><span className="c27">AlumSum shares tracking cookie data with the following nonaffiliates when you click on their links: Lendkey Technologies, Inc., Earnest, Splash Financial, and SoFi. Remember that any information you provide to nonaffiliates, whether through us or on your own, will be subject to their privacy practices and terms and conditions.</span></li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr className="c23">
                                        <td className="c22">
                                            <p className="c9 c18"><span className="c17"><strong>Joint marketing</strong></span></p>
                                        </td>
                                        <td className="c49">
                                            <p className="c9 c18"><span className="c27">A formal agreement between nonaffiliated financial companies that together market financial products or services to you.</span></p>
                                            <ul className="c28 lst-kix_list_6-0 start">
                                                <li className="c19 c18"><span className="c27">AlumSum doesn’t jointly market.</span></li>
                                            </ul>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <p className="c59 c18 c29"></p>
                                <table className="c36">
                                    <tbody>
                                    <tr className="c52">
                                        <td className="bold-white-grey-text" colSpan="1">
                                            <p className="c16"><span className="c12"><strong>Other important information</strong></span></p>
                                        </td>
                                    </tr>
                                    <tr className="c43">
                                        <td className="c11">
                                            <p className="c53 c18"><span className="c17"><strong>For California Customers</strong></span><span className="c3">: In accordance with California law, we will not share information we collect about California residents with nonaffiliates, unless the law allows.</span></p>
                                            <p className="c18 c53"><span className="c17"><strong>Additional information</strong>: Additional information concerning our privacy policies can be found at: <a className="c7" href="http://alumsum.com/contact">http://alumsum.com/contact</a></span></p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                        </div>
                </div>
            </div>
        );
    }
};

export default withRouter(Glbf);